import i18n from 'services/base/i18n';

export default {
  // Save button
  save: () => i18n.pgettext('Pages|Edit Pangolin', 'SAVE'),
  // Label for input box for the name of the Pangolin
  nickname: () => i18n.pgettext('Pages|Edit Pangolin', 'PANGOLIN NAME'),
  // Label for input box for the timezone of the Pangolin
  timezone: () => i18n.pgettext('Pages|Edit Pangolin', 'DEVICE TIMEZONE'),
};